module.exports = __webpack_public_path__ + "img/ic-instagram.7aca5d56.svg";